<template>
  <section>
    <div class="container">
      <FormRegist />
    </div>
  </section>
</template>

<script>
  import FormRegist from "./components/Form";
  export default {
    name: "Registration",
    components: {
      FormRegist,
    },
  };
</script>

<style></style>
